import { createAnonAxios } from "./vg2AnonAxios";

const API_V2 = `${process.env.REACT_APP_BACKEND_URL}/api/v2`;
const api = createAnonAxios(API_V2);

// Idempotent generate: same operation_id per (caseId) → same version.
export const generateDecision = async (caseId, operationId) =>
  (await api.post(`/cases/${caseId}/decision/generate`,
    { operation_id: operationId })).data;

// Read-only fetch of the current DECIDI view.
export const getDecision = async (caseId) =>
  (await api.get(`/cases/${caseId}/decision`)).data;

// V3 · «Cosa emerge dall'analisi» salvato sulla versione DECIDI indicata.
export const getDecidiInsight = async (caseId, decisionResultId, scenarioKey) =>
  (await api.get(`/cases/${caseId}/decision/insight`, {
    params: { decision_result_id: decisionResultId, ...(scenarioKey ? { scenario_key: scenarioKey } : {}) },
    timeout: 60000,
  })).data;

// §Micro8 · Analizza on-demand UN solo scenario segnaposto (sincrono).
// Nessun timeout client specifico: si lascia operare i limiti
// infrastrutturali esistenti. Ritorna { view, analyzed_scenario_key,
// already_analyzed, analyze_meta }.
export const analyzeScenario = async (caseId, scenarioKey) =>
  (await api.post(
    `/cases/${caseId}/decision/scenario/${scenarioKey}/analyze`)).data;

// Submit owner choice with server-side validation.
export const postOwnerChoice = async (caseId, payload) =>
  (await api.post(`/cases/${caseId}/decision/owner-choice`, payload)).data;

// M8.2 · Generate a compare-synthesis paragraph via Claude Sonnet.
// Returns { synthesis_text, cached_at, source } or throws.
export const postCompareSynthesis = async (caseId, scenarioKeys) =>
  (await api.post(`/cases/${caseId}/decision/compare-synthesis`, {
    scenario_keys: scenarioKeys,
  })).data;

// M8.5 · DECIDI checklist — lista documenti+professionisti+risposte.
export const getDecidiChecklist = async (caseId, scenarioKey) => {
  const qs = scenarioKey ? `?scenario_key=${encodeURIComponent(scenarioKey)}` : "";
  return (await api.get(`/cases/${caseId}/decision/checklist${qs}`)).data;
};

// Aggiorna la risposta di un singolo item della checklist.
export const patchDecidiChecklistItem = async (caseId, { scenarioKey, itemId, status }) =>
  (await api.patch(`/cases/${caseId}/decision/checklist`, {
    scenario_key: scenarioKey,
    item_id: itemId,
    status,
  })).data;

export function decidiOpIdKey(caseId) {
  return `vg2_decidi_op_${caseId}`;
}

export function getDecidiOpId(caseId) {
  let op = localStorage.getItem(decidiOpIdKey(caseId));
  if (!op) {
    op = "dop_" + Math.random().toString(36).slice(2, 14);
    localStorage.setItem(decidiOpIdKey(caseId), op);
  }
  return op;
}

export function choiceOpIdKey(caseId, choiceType, selectedKey) {
  const suffix = selectedKey ? `_${selectedKey}` : "";
  return `vg2_decidi_choice_op_${caseId}_${choiceType}${suffix}`;
}

export function newChoiceOpId(caseId, choiceType, selectedKey) {
  // For each explicit change we mint a fresh op_id so the backend appends
  // a new choice_version rather than returning the idempotent match.
  const op = "cop_" + Math.random().toString(36).slice(2, 14);
  localStorage.setItem(choiceOpIdKey(caseId, choiceType, selectedKey), op);
  return op;
}
